import React, { useEffect, useState } from "react";
import { Autocomplete, useDebounce } from "@sscs/ui";
const BehaviorDescriptionFilter = ({ description, descriptionOptions, label, onChange, className, loading, onOpen, ...props }) => {
    var _a;
    const [localDescription, setLocalDescription] = useState(description);
    useEffect(() => {
        setLocalDescription(description);
    }, [description]);
    useDebounce(localDescription, undefined, (value) => {
        if (description !== value) {
            onChange(value);
        }
    });
    return (React.createElement(Autocomplete, { id: "filter-behavior-description", className: className, loading: loading, isClearAlwaysVisible: localDescription !== "", freeSolo: true, value: localDescription, options: descriptionOptions, filterOptions: (props) => props.filter((item) => localDescription
            ? item.toLowerCase().includes(localDescription)
            : true), label: label !== null && label !== void 0 ? label : "Search for behavior descriptions", inputProps: {
            maxLength: 512,
        }, onOpen: onOpen, onInputChange: (_event, value) => {
            setLocalDescription(value);
        }, "data-filtered-by-link": (_a = props["data-filtered-by-link"]) !== null && _a !== void 0 ? _a : false }));
};
export default BehaviorDescriptionFilter;
//# sourceMappingURL=BehaviorDescriptionFilter.js.map